'use strict';

/*global diffTime*/
/*global formatedTime*/
/*global formatTimeHM*/
function StopwatchesService() {
  this.$container = null;
  this.init();
}

StopwatchesService.prototype = $.extend({}, {
  constructor: 'StopwatchesService',

  //----------------------------------------------------------------------------

  getStopwatchTime: function getStopwatchTime(timeStart) {
    return diffTime(timeStart, new Date());
  },

  incStopwatches: function incStopwatches() {
    var _this = this;

    _this.$container.find('.stopwatch:not(.stopwatch--paused)').each(function () {
      var $stopwatch = $(this);
      var timeStart = parseInt($stopwatch.data('time_start'));
      var time = _this.getStopwatchTime(timeStart);
      var timeFormated = formatedTime(_this.getStopwatchTime(timeStart));
      $stopwatch.find('.stopwatch-timer').text(timeFormated);
      $stopwatch.find('.stopwatch-start-time').text(formatTimeHM(timeStart));

      $stopwatch.data('time', time);
      $stopwatch.trigger('stopwatch-update');
    });

    return _this;
  },

  init: function init() {
    var _this = this;

    _this.$container = $('body');

    setInterval(function () {
      _this.incStopwatches();
    }, 1000);

    _this.incStopwatches();
  }
});
